import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import {
	SdfBox,
	SdfMultiSelect,
	SdfSearch,
	SdfSegmentedControl,
} from '@synerg/react-components';

export const SearchHeader = (props = {}) => {
	const {
		projectID, prodProjectID, projectDetails, getActiveCR, modifyScopeSuccess, getCarDetails,
		selectedEnvironment, setSelectedEnvironment, searchedText, setSearchedText, searchedStatus,
		setSearchedStatus
	} = props || {};

	const statusList = ['Active', 'Suspended', 'Canceled'];

	// segment states
	const [segmentList, setSegmentList] = useState([{ label: 'Dev', value: 0 }, { label: 'Prod', value: 1 }]);
	const [selectedSegment, setSelectedSegment] = useState(1);

	const handleEnvironmentSelection = (selection) => {
		const environment = selection === 0 ? 'DEV' : 'PROD';
		setSelectedEnvironment(environment);
		setSelectedSegment(selection);
	};

	const setDefaults = (hasProdData, hasDevData) => {
		setSegmentList(prev => (prev.map(item => ({ ...item, disabled: (item.label === 'Prod' && !hasProdData) || (item.label === 'Dev' && !hasDevData)}))));
		setSelectedSegment(hasProdData ? 1 : 0);
		setSelectedEnvironment(hasProdData ? 'PROD' : 'DEV');
	};

	useEffect(() => {
		if (selectedEnvironment) {
			if (selectedEnvironment === 'DEV' && projectID) {
				getActiveCR(projectID);
			} else if (prodProjectID) { 
				getActiveCR(prodProjectID);
			}

			// call details API
			getCarDetails({}, selectedEnvironment);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedEnvironment, prodProjectID, projectID, modifyScopeSuccess]);

	useEffect(() => {
		// call details API
		getCarDetails(
			{
				searchText: searchedText,
				selectedSubscriptions: searchedStatus
			},
			selectedEnvironment
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchedText, searchedStatus]);

	useEffect(() => {
		const hasProdData = get(projectDetails, 'legacy', false) && get(projectDetails, 'type', '') === 'PROD'
			? get(projectDetails, '_id', '')
			: get(projectDetails, 'associatedProject._id', '');
		const hasDevData = (get(projectDetails, 'type', '') === 'DEV' || get(projectDetails, 'associatedProject.type', '') === 'DEV');
		setDefaults(hasProdData, hasDevData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [projectDetails]);

	return (
		<div className="w-full">
			<SdfBox variant="filled" className="my-5 p-5">
				<div className="flex justify-center">
					<SdfSegmentedControl
						className="border-dark border-solid border-1 border-opacity-25"
						items={segmentList}
						onSdfChange={({ detail }) => handleEnvironmentSelection(detail)}
						selectedIndex={selectedSegment}
					/>
				</div>

				<div className={"flex justify-between gap-6 mt-6 pb-4"}>
					<SdfSearch
						className={"w-full"}
						label={"Search"}
						placeholder={"Search by client name or OOID"}
						value={searchedText}
						onSdfSearch={({ detail }) => {
							setSearchedText(detail);
						}}
					/>

					<div>
						<SdfMultiSelect
							label={"Subscription status"}
							items={statusList.map((opt) => ({ label: opt, value: opt }))}
							filterable={true}
							inputWidth={"lg"}
							value={searchedStatus}
							onSdfChange={({ detail }) => {
								setSearchedStatus(detail);
							}}
							placeholder="Select..."
							defaultSearchTerm=""
						/>
					</div>
				</div>
			</SdfBox>
		</div>
	);
};
